import { motion } from "framer-motion";

const fleet = [
    { name: "Rolls Royce", line: "Phantom · Ghost · Cullinan" },
    { name: "Bentley", line: "Mulsanne · Flying Spur" },
    { name: "Range Rover", line: "SV Autobiography" },
    { name: "BMW I7", line: "Electric flagship saloon" },
    { name: "Mercedes SClass", line: "Long wheelbase" },
    { name: "Mercedes VClass", line: "Group travel 7 passengers" },
    { name: "Mercedes Sprinter", line: "Group travel 9-17 passengers" },
    {
        name: "Aviation",
        line: "Light, Mid-size & long-range jets · VIP Airliners · Helicopters",
        partner: "Managed in collaboration with Jetimmobilier",
    },
    {
        name: "Yachts",
        line: "Mediterranean · Caribbean · on charter",
        partner: "Managed in collaboration with Jetimmobilier",
    },
    {
        name: "Villas",
        line: "Exclusive villas in the world's most desirable destinations",
        partner: "Managed in collaboration with Jetimmobilier",
    },
];

export default function Fleet() {
    return (
        <section
            id="fleet"
            data-testid="fleet-section"
            className="relative bg-cream py-24 md:py-40 overflow-hidden"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-4">
                        <span className="font-sans text-[10px] uppercase tracking-[0.4em] text-oxblood">
                            № III - Conveyance
                        </span>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1 }}
                            className="font-serif text-[2.2rem] md:text-[3rem] leading-[1.1]"
                        >
                            Luxury Transportation
                            <br />
                            <span className="italic">for the well discerning.</span>
                        </motion.h2>
                        <p className="mt-6 font-sans text-[14px] md:text-[15px] text-[#1A1A1A]/70 max-w-2xl leading-[1.85]">
                            Any mode of transport can be arranged for any occasion. Whether by
                            land, by sea or by sky. Anything beyond those listed can be
                            privately sourced upon request.
                        </p>
                    </div>
                </div>

                <div className="border-t border-bone">
                    {fleet.map((f, idx) => (
                        <motion.div
                            key={f.name}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-40px" }}
                            transition={{ duration: 0.8, delay: idx * 0.04 }}
                            data-testid={`fleet-item-${f.name.toLowerCase().replace(/\s|-/g, "-")}`}
                            className="group grid grid-cols-12 gap-4 md:gap-6 border-b border-bone py-7 md:py-10 cursor-default transition-colors duration-500 hover:bg-surface/60"
                        >
                            <div className="col-span-12 md:col-span-7 font-serif text-[1.7rem] md:text-[2.4rem] leading-tight tracking-tight transition-colors duration-500 group-hover:text-oxblood">
                                {f.name}
                            </div>
                            <div className="col-span-12 md:col-span-5 md:pl-6 md:pt-5 md:text-right">
                                <div className="font-sans text-[12px] md:text-[13px] uppercase tracking-[0.22em] text-[#595959]">
                                    {f.line}
                                </div>
                                {f.partner && (
                                    <div className="mt-2 font-serif italic text-[12px] md:text-[13px] text-[#C5A880]">
                                        {f.partner}
                                    </div>
                                )}
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.p
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, delay: 0.2 }}
                    className="mt-16 md:mt-20 font-serif italic text-[18px] md:text-[22px] text-oxblood text-center md:text-left"
                >
                    "If it moves, by land, by sea, by sky, it can be arranged."
                </motion.p>
            </div>
        </section>
    );
}
